import BlockContent from '../BlockContent';

const ClassNameWrapper = ({ body, className }) => {
  if (!body || !className) {
    return null;
  }
  return (
    <div className={className}>
      <BlockContent content={body} />
    </div>
  );
};

export default ClassNameWrapper;
